import { render, staticRenderFns } from "./Edit_process.vue?vue&type=template&id=82cf3586&scoped=true&"
import script from "./Edit_process.vue?vue&type=script&lang=js&"
export * from "./Edit_process.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cf3586",
  null
  
)

export default component.exports